"use strict";

//REMINDER: La url de youtube debe tener estos parametros ?enablejsapi=1&rel=0

const endYoutubeVideo = (nodesIframesArray) => {

    //End youtube video when iframe contains "playerIframe" class
    nodesIframesArray.forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
    })

}


export {
    endYoutubeVideo
};
